var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1296 21.5311L24.5609 19.3894C24.9398 17.5985 24.5827 15.6579 23.4288 14.0688L29.2479 8.24977C32.1877 10.0385 35.9993 7.91648 35.9993 4.44797C36 1.99477 34.0052 0 31.5527 0C28.0807 0 25.9636 3.81445 27.7509 6.75141L21.9319 12.5705C19.4337 10.7564 16.008 10.8802 13.6434 12.9059L10.6819 10.3887C12.1591 7.4482 10.0111 3.95227 6.70641 3.95227C4.25461 3.95227 2.25914 5.94703 2.25914 8.39953C2.25914 12.0389 6.39984 14.1103 9.30938 12.0016L12.2702 14.5188C10.8696 16.8159 10.9807 19.7409 12.5712 21.9312L8.69766 25.8047C5.03438 23.3213 0 25.9397 0 30.4235C0 33.4983 2.50172 36 5.57648 36C10.0568 36 12.6816 30.9691 10.1953 27.3023L14.0688 23.4288C15.6923 24.6073 17.7188 24.9764 19.6059 24.5109L22.0134 30.2013C19.7353 32.2221 21.1683 36 24.2121 36C26.0416 36 27.5295 34.5115 27.5295 32.6827C27.5295 30.7814 25.9137 29.2296 23.9625 29.3752L21.555 23.6841C22.4775 23.1047 23.2502 22.308 23.7994 21.3652L29.3688 23.5076C29.2894 25.4046 30.8109 26.9655 32.6827 26.9655C34.5122 26.9655 36 25.477 36 23.6482C36 20.5699 32.1188 19.1355 30.1296 21.5311Z",
    fill: "#11A0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotype);
export default __webpack_public_path__ + "static/media/logotype.777362fbbaacbe4785eba386ee93564b.svg";
export { ForwardRef as ReactComponent };